module.exports = __webpack_public_path__ + "media/images/gm_icon01-b65f36d435ed0f529c4e13b0b6c0a7c1.png";